import { render } from "./AuthAnime.vue?vue&type=template&id=c485adfa&scoped=true"
import script from "./AuthAnime.vue?vue&type=script&lang=js"
export * from "./AuthAnime.vue?vue&type=script&lang=js"

import "./AuthAnime.vue?vue&type=style&index=0&id=c485adfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c485adfa"]])

export default __exports__